<div class="flex flex-col gap-1 border border-rounded-sm p-2 rounded bg-slate-100" [ngClass]="{ 'border-slate-300' : !hasValue, 'border-ponder-link' : hasValue }">
    <div class="flex flex-row gap-2 items-center">
        <label class="text-xs sm:text-sm grow" [ngClass]="{ 'text-slate-700' : !hasValue, 'text-ponder-link' : hasValue }">{{ type }}</label>
        @if (hasValue) {
            @if (allowAnd) {
                <button (click)="onToggleLogicalMode()" class="rounded shadow-sm text-white bg-ponder-link hover:bg-ponder-linkhover p-[2px] pl-2 pr-2 text-xs font-mono w-[6ch]">
                    @if (logicalAnd) {
                        AND
                    } @else {
                        OR
                    }
                </button>
            } @else {
                <div class="rounded shadow-sm text-white bg-slate-400 cursor-default p-[2px] pl-2 pr-2 text-xs font-mono w-[6ch] text-center">
                    OR
                </div>
            }
            <button (click)="onClear()">
                <svg-icon [svgIcon]="closeSvgIcon" [small]="true" class="fill-none stroke-ponder hover:stroke-ponder-link"></svg-icon>
            </button>
        }
    </div>
    @for (item of selectedItems ; track item.key) {
        <div class="flex flex-row gap-2 text-xs sm:text-sm">
            <button (click)="onDeselectItem(item)"><svg-icon [svgIcon]="closeSvgIcon" [small]="true" class="fill-none stroke-ponder hover:stroke-ponder-link"></svg-icon></button>
            <div class="grow">{{ item.key }}</div>
        </div>
    }
    @if (canSelect())
    {
        <searchable-dropdown-list (onSelect)="onChange($event)" [keys]="keys" [values]="values"></searchable-dropdown-list>
        <!--
        @if (availableIndices.length > 0) {
            <select #selectInput (input)="onChange(selectInput.value)" class="p-1 text-xs sm:text-sm bg-slate-50 rounded-sm shadow-sm grow disabled:bg-opacity-50">
                <option value="-1" disabled selected></option>
                @for (availableIndex of availableIndices ; track availableIndex) {
                    <option [attr.value]="availableIndex">{{ values[availableIndex] }}</option>
                }
            </select>
        }
        -->
    } @else {
        <div class="text-xs text-slate-400">Limit of 5 active selections</div>
    }
</div>